import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Components
import IconButton from "../Atoms/IconButton";

// Stylesheets
import "./HamburgerIcon.scss";

// Hamburger icon
const HamburgerIcon = ({ isOpen, onClick, className }) => {
  const iconWrapperClass = classNames("hamburger_icon_container", className);

  const iconClass = classNames("hamburger_icon", { is_open: isOpen });

  const ariaLabel = isOpen ? "Close Menu" : "Open Menu";

  return (
    <IconButton
      className={iconWrapperClass}
      onClick={onClick}
      ariaLabel={ariaLabel}
      tabIndex={2}
    >
      <i className={iconClass}>
        <span className="hamburger_icon_inner"></span>
      </i>
    </IconButton>
  );
};

HamburgerIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.any,
};

export default HamburgerIcon;
